/**
 * SortControl Component
 * Sort dropdown with order direction toggle
 */
import React from "react";
import PropTypes from "prop-types";
import "./SortControl.scss";

export const SortControl = ({
  value,
  onChange,
  orderValue = "desc",
  onOrderChange,
  options = [],
  disabled = false,
  className = "",
}) => {
  return (
    <div
      className={`sort-control ${
        disabled ? "sort-control--disabled" : ""
      } ${className}`}
    >
      <select
        className="sort-control__select"
        value={value}
        onChange={(e) => onChange && onChange(e.target.value)}
        disabled={disabled}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {onOrderChange && (
        <button
          className="sort-control__order"
          onClick={() => onOrderChange(orderValue === "asc" ? "desc" : "asc")}
          disabled={disabled}
          title={orderValue === "asc" ? "Ascending" : "Descending"}
        >
          {orderValue === "asc" ? "↑" : "↓"}
        </button>
      )}
    </div>
  );
};

SortControl.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  orderValue: PropTypes.oneOf(["asc", "desc"]),
  onOrderChange: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};
